import { commonModule, installationsModule } from '@/store/modules/store-accessor';

export type InstallationSideviewPayload = {
  installationId: string | number;
  tab?: string | number;
  jobId?: number;
  appointmentId?: number;
  recurrenceId?: number;
  taskId?: number;
};

/**
 * Load sideview header + target tab data, then open the sideview.
 * Throws if the installation cannot be loaded (e.g. deleted).
 */
export async function openInstallationSideview(payload: InstallationSideviewPayload): Promise<void> {
  await installationsModule.prepareInstallationSideview({
    installationId: String(payload.installationId),
    tab: payload.tab,
  });

  commonModule.showSideview({
    name: 'installations-sideview',
    payload,
  });
}
